import { useEffect, useState, type ReactNode } from 'react';

interface ProgressRingProps {
  /** 0 a 100. */
  valor: number;
  tamanho?: number;
  espessura?: number;
  children?: ReactNode;
  className?: string;
}

// Anel de progresso (sem SVG): conic-gradient com furo no meio. Anima de 0
// até o valor em 600 ms ease-out ao aparecer.
export default function ProgressRing({
  valor,
  tamanho = 180,
  espessura = 14,
  children,
  className = '',
}: ProgressRingProps) {
  const alvo = Math.max(0, Math.min(100, valor));
  const [atual, setAtual] = useState(alvo);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) {
      setAtual(alvo);
      return;
    }
    let raf = 0;
    const inicio = performance.now();
    const dur = 600;
    const passo = (t: number) => {
      const p = Math.min(1, (t - inicio) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      setAtual(alvo * e);
      if (p < 1) raf = requestAnimationFrame(passo);
    };
    raf = requestAnimationFrame(passo);
    return () => cancelAnimationFrame(raf);
  }, [alvo]);

  const furo = `radial-gradient(farthest-side, transparent calc(100% - ${espessura}px), #000 calc(100% - ${espessura}px))`;

  return (
    <div
      className={`relative flex items-center justify-center ${className}`}
      style={{
        width: tamanho,
        height: tamanho,
        borderRadius: '9999px',
        background: `conic-gradient(oklch(var(--primary-500)) ${atual}%, oklch(var(--background-200)) 0)`,
        mask: furo,
        WebkitMask: furo,
      }}
    >
      {children && (
        <div style={{ mask: 'none', WebkitMask: 'none' }} className="flex flex-col items-center justify-center text-center">
          {children}
        </div>
      )}
    </div>
  );
}